import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Whitelist of authorized UIDs
const AUTHORIZED_UIDS = ['gZTDKq4Gg9aKtLRtvZU0TP7uQST2', 'lshstasFWvPDs51NwpfL2mJ84XC2'];

export default function ProtectedRoute() {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!AUTHORIZED_UIDS.includes(user.uid)) {
        return (
            <div className="unauthorized-page">
                <div className="unauthorized-content">
                    <h1>404 - Not Found</h1>
                    <p>The page you're looking for doesn't exist.</p>
                    <button
                        onClick={() => window.location.href = '/login'}
                        className="back-btn"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        );
    }

    return <Outlet />;
}
